<template>
  <form-skeleton ref="formParent" layout="inline" @skeleton-submit="handleSearch">
    <template #time>
      <a-form-item>
        <a-date-picker
          :initialValue="moment(new Date())"
          :format="dateFormat"
          :disabled-date="startDateDisabledDate"
          @change="startDateChange"
          v-decorator="['startDate']" style="vertical-align: middle;width:150px;margin-right:10px" />
      </a-form-item>
      <a-form-item>
        <a-date-picker
          v-decorator="['endDate']"
          :disabled-date="disabledDate"
          :initialValue="moment(new Date())" :format="dateFormat"
          style="vertical-align: middle;width:150px;margin-right:10px" />
      </a-form-item>
    </template>
    <slot slot-scope="slotProps"></slot>
    <template #submit v-if="show">
      <a-form-item>
        <a-button type="primary" html-type="submit">查询</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" ghost @click="resetFields">清空</a-button>
      </a-form-item>
    </template>
  </form-skeleton>
</template>

<script>
import moment from "moment";
import formSkeleton from "./formSkeleton";

export default {
  components: {
    formSkeleton
  },
  props: {
    callback: {
      type: Function,
      default: (value) => value
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dateFormat: "YYYY/MM/DD",
      startDate: undefined // 关联 disabledDate
    };
  },
  methods: {
    moment,
    resetFields() {
      this.$refs?.formParent?.form?.resetFields();
      // this.$emit("handle-submit", {});
    },
    handleSearch(values) {
      const { startDate, endDate } = values;
      const payload = {
        ...values,
        startDate: startDate ? moment(startDate).format(this.dateFormat) : undefined,
        endDate: endDate ? moment(endDate).format(this.dateFormat) : undefined
      };
      this.callback && this.callback(payload);
      this.$emit("handle-submit", payload);
    },
    disabledDate(endValue) {
      const startValue = this.startDate;
      if (!startValue) {
        return endValue.valueOf() > moment();
      }
      // 如果有开始时间  结束时间不能大于开始时间和当天
      return endValue.valueOf() < moment(this.startDate).valueOf() || endValue.valueOf() > moment();
    },
    startDateDisabledDate(current) {
      // Can not select days before today and today
      return current && current > moment();
    },
    startDateChange(val) {
      this.startDate = moment(val).format(this.dateFormat);
      this.$refs.formParent.form.setFieldsValue({
        endDate: undefined
      });
    }

  }
};
</script>

<style scoped>

</style>
